import { useDSTranslation } from '@libs/ui/ds'
import type { FC } from 'react'

import { Flex } from '../../../../primitiveLayouts/Flex/base/Flex'
import { Stack } from '../../../../primitiveLayouts/Stack/base/Stack'
import { Alert } from '../Alert'

import type { AlertErrorAdapterProps } from './AlertErrorAdapter.types'

export const AlertErrorAdapter: FC<AlertErrorAdapterProps> = ({
  error,
  ...other
}) => {
  const { t } = useDSTranslation()

  if (!error) {
    return null
  }

  if (error?.message) {
    return (
      <Alert intent='semantic.red' title={error?.message} {...other}>
        {Boolean(error?.details?.length) && (
          <Stack col gap={2}>
            {(error?.details || []).map((detail, idx) => {
              return <Flex key={idx}>{detail.message}</Flex>
            })}
          </Stack>
        )}
      </Alert>
    )
  }

  return (
    <Alert intent='semantic.red' {...other}>
      {t('ds.globals.errors.genericError')}
    </Alert>
  )
}

export type {
  AlertErrorAdapterProps,
  BackendStandardError
} from './AlertErrorAdapter.types'
